













import { Prop, Component, Vue, Ref } from 'vue-property-decorator';
import Blizzard from '@/services/Blizzard';

@Component
export default class BodyTraitPreview extends Vue {
  @Prop(String) readonly previewSrc: string | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;
  @Ref('trait') readonly trait: HTMLImageElement | undefined;

  get errorImageSrc(): string {
    return require('@/assets/reload_failed.png');
  }

  onLoadEnd(): void {
    Blizzard.recordTraitPreviewLoad(false);
  }

  onError(): void {
    Blizzard.recordTraitPreviewLoad(true);

    if (this.$refs && this.trait) {
      this.trait.src = this.errorImageSrc;
    }
  }
  onClick(): void {
    if (this.$refs && this.trait && this.trait.src === this.errorImageSrc) {
      // retry loading all unloaded preview images in the grid when user clicks
      // on refresh icon
      this.$parent.$emit('reload-category-grid');
    } else {
      this.$emit('on-select-option');
    }
  }
}
